import React from "react";
import { useHistory } from "react-router-dom";

export default function DataExport({ onClose }) {
  const history = useHistory();

  const handleStartCancellation = () => {
    history.push("/settings/deleteaccount/:seperator"); // 👈 MUST
  };

  const handleClose = () => {
    history.goBack(); // 👈 THIS WILL GO BACK
  };

  return (
    <div className="data-export-overlay">
      <div className="data-export-modal">
        {/* Header */}
        <div className="data-export-title">Data Export Availability</div>
        <div className="data-export-subtitle">
          Data export is available at the end of the account cancellation
          process
        </div>
        <div className="account-reactivate-divider" />
        {/* Info Box */}
        <div className="data-export-infobox">
          <div className="data-export-infobox-title">
            To Export your data, Follow these steps:
          </div>
          <ul className="data-export-steps">
            <li>Select a reason for cancellation on the reasons page.</li>
            <li>
              On the export page, download your password - protected data file
            </li>
            <li>Acknowledge and confirm the cancellation</li>
          </ul>
        </div>

        {/* Note */}
        <div className="data-export-note">
          <strong>Note:</strong> Cancelled accounts can be reactivated at any
          time
        </div>

        {/* Actions */}
        <div className="data-export-actions">
          <button className="data-export-close-btn" onClick={handleClose}>
            Close
          </button>
          <button
            className="data-export-start-btn"
            onClick={handleStartCancellation}
          >
            Start Cancellation
            <span className="btn-arrow">→</span>
          </button>
        </div>
      </div>
    </div>
  );
}
